import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * CrashClawConfig — CrashClaw 配置页面壳组件
 *
 * 页面结构：
 *   1. Title 行（FaRobot icon + "CrashClaw 配置"）
 *   2. 描述文字 + 说明文档链接
 *   3. Tab 切换（工作区 / 连接器 / 技能 / 知识库）
 *   4. 根据当前 Tab 渲染对应子面板
 */
import { useMemo, useState } from 'react';
import { FaRobot } from 'react-icons/fa';
import { ze } from 'utils/zhEn';
import CrashClawSkillsPanel from './CrashClawSkillsPanel';
import CrashClawWorkspacePanel from './CrashClawWorkspacePanel';
import CrashClawConnectorPanel from './CrashClawConnectorPanel';
import CrashClawKnowledgePanel from './CrashClawKnowledgePanel';
import style from './style.scss';
const TAB_OPTIONS = [
    { key: 'workspace', label: ze('工作区', 'Workspace') },
    { key: 'connectors', label: ze('连接器', 'Connectors') },
    { key: 'skills', label: ze('技能', 'Skills') },
    { key: 'knowledge', label: ze('知识库', 'Knowledge') },
];
const TAB_KEYS = ['workspace', 'connectors', 'skills', 'knowledge'];
const CrashClawConfig = () => {
    // 支持 URL 上带 `crashClawTab` 直接定位到某个 Tab（如工作区详情弹窗"授权仓库"里
    // 引导用户跳转「连接器」完成工蜂 OAuth 授权，见 RepoAuthorizeModal.tsx）
    const initialTab = useMemo(() => {
        const tab = new URLSearchParams(window.location.search).get('crashClawTab');
        return TAB_KEYS.includes(tab || '') ? tab : 'workspace';
    }, []);
    const [activeTab, setActiveTab] = useState(initialTab);
    const initialWorkspaceUid = useMemo(() => {
        const uid = new URLSearchParams(window.location.search).get('workspaceUid');
        return uid || undefined;
    }, []);
    return (_jsxs("div", { children: [_jsxs("div", { className: style.crashClawTop, children: [_jsx(FaRobot, { size: 14 }), _jsx("div", { children: ze('CrashClaw 配置', 'CrashClaw Config') })] }), _jsxs("div", { className: style.crashClawDesc, children: [ze('三步完成接入：创建工作区 → 接入连接器 → 启用技能。即可获得全链路自动化崩溃修复能力。知识库用于向 Agent 下发可检索资料（iWiki / 本地）。', 'Three steps: create a workspace, connect connectors, enable skills. Knowledge bases feed Agent-searchable docs (iWiki / local).'), _jsx("a", { className: style.docsLink, href: "/account/profile?tag=crashClawDocs", target: "_blank", rel: "noopener noreferrer", children: ze('查看说明文档', 'View Documentation') })] }), _jsx("div", { className: style.configTabs, children: TAB_OPTIONS.map(tab => (_jsx("button", { className: `${style.configTab} ${activeTab === tab.key ? style.configTabActive : ''}`, onClick: () => setActiveTab(tab.key), children: tab.label }, tab.key))) }), activeTab === 'workspace' && (_jsx(CrashClawWorkspacePanel, { initialWorkspaceUid: initialWorkspaceUid })), activeTab === 'connectors' && _jsx(CrashClawConnectorPanel, {}), activeTab === 'skills' && _jsx(CrashClawSkillsPanel, {}), activeTab === 'knowledge' && (_jsx(CrashClawKnowledgePanel, { onNavigateToConnectors: () => setActiveTab('connectors') }))] }));
};
export default CrashClawConfig;
